import { observer } from 'mobx-react';
import { TLCode, Page } from '../../common/enums';
import glamorous from 'glamorous';
import React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { FormComponentProps } from 'antd/lib/form';
import { Form } from 'react-final-form';
import { toJS } from 'mobx';
import { Intent, Button } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import VerticalForm from '../common/form/VerticalForm';
import { DateInputFormField, PharmacyFormField, SelectInputFormField, TextAreaFormField } from '../common/form';
import { Link } from 'react-router-dom';
import { TranslatedMessage } from '../common/translation';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import moment from 'moment';
import { Instance } from 'mobx-state-tree';
import { BlackPoint } from '../../store/models/BlackPoint';
import { Pharmacy } from '../../store/models/Pharmacy';
import { BlackPointType } from '../../store/models/BlackPointType';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
interface BlackPointFormProps extends WithTranslateProps, FormComponentProps {
  blackPoint: Instance<typeof BlackPoint>;
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  blackPointTypeList: Array<Instance<typeof BlackPointType>>;
  save: (data: any) => void;
  getTypeById: (id: number) => any;
}
const Container = glamorous.div({
  display: 'flex',
  width: '50%',
  flexDirection: 'column',
});
const ButtonsContainer = glamorous.div({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'flex-end',
  '& button': {
    marginLeft: 5,
  },
});
@observer
class BlackPointForm extends React.Component<BlackPointFormProps> {
  renderTypeMenuItem(item: Instance<typeof BlackPointType>, { handleClick, index, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return <MenuItem key={`type-${index}`} active={modifiers.active} onClick={handleClick} text={item.name!} />;
    } else {
      return null;
    }
  }
  filterType = (query, type) => {
    return type.name!.toLowerCase().indexOf(query.toLowerCase()) >= 0;
  };
  render() {
    const { blackPoint, save, pharmacyList, blackPointTypeList, getTypeById, translate, ...otherProps } = this.props;
    const blackpointJS: any = toJS(blackPoint);
    if (blackpointJS) {
      blackpointJS.startDate = moment(blackPoint.startDate).toDate();
      blackpointJS.endDate = moment(blackPoint.endDate).toDate();
    }
    return (
      <Form
        initialValues={blackpointJS}
        onSubmit={save}
        render={({ handleSubmit, form, hasValidationErrors, dirty, values }) => (
          <form onSubmit={handleSubmit}>
            <LeaveRouteDirtyWrapper blockChange={dirty} />
            <Container>
              <VerticalForm labelWidth={175}>
                <PharmacyFormField pharmacyList={pharmacyList} required={true} />
                <DateInputFormField
                  name="startDate"
                  required={true}
                  label={TLCode.BLACKPOINT_StartDate}
                  inline={true}
                  fill={true}
                  onChange={() => console.log('onchange')}
                  maxDate={moment()
                    .add(20, 'year')
                    .toDate()}
                />
                <DateInputFormField
                  name="endDate"
                  required={true}
                  label={TLCode.BLACKPOINT_EndDate}
                  inline={true}
                  fill={true}
                  maxDate={moment()
                    .add(20, 'year')
                    .toDate()}
                />
                <SelectInputFormField
                  label={TLCode.BLACKPOINT_Type}
                  name="blackPointTypeId"
                  inline={true}
                  items={toJS(blackPointTypeList)}
                  itemValueGetter={(item: { blackPointTypeId: number; name: string }) => item.blackPointTypeId}
                  valueItemGetter={(value) => getTypeById(value)!}
                  inputValueRenderer={(item) => (item != null ? item.name! : '')}
                  itemRenderer={this.renderTypeMenuItem}
                  itemPredicate={this.filterType}
                  allowEmpty={true}
                  identifier={'blackPointTypeId'}
                  elementLabel={'name'}
                  labelSelectAnElement={this.props.translate(TLCode.BLACKPOINT_Choose_Type)}
                  helperText={this.props.translate(TLCode.CHOOSE_A_TYPE)}
                  required={true}
                  {...otherProps}
                />
                <TextAreaFormField name="comment" label={TLCode.BLACKPOINT_Comment} inline={true} />
              </VerticalForm>
              <ButtonsContainer>
                <Button>
                  <Link to={`${Page.BlackPoints}`}>
                    <TranslatedMessage id={TLCode.BackToList} />
                  </Link>
                </Button>
                <Button
                  text={translate(TLCode.GENERAL_Cancel)}
                  icon={IconNames.ERASER}
                  intent={Intent.PRIMARY}
                  onClick={() => form.reset()}
                  disabled={!dirty}
                />
                <Button
                  type={'submit'}
                  text={translate(TLCode.GENERAL_Save)}
                  icon={IconNames.FLOPPY_DISK}
                  intent={Intent.PRIMARY}
                  disabled={hasValidationErrors || !dirty}
                />
              </ButtonsContainer>
            </Container>
          </form>
        )}
      />
    );
  }
}
export default withTranslate(BlackPointForm);
